var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableau = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 0.5H11.375V5H12.125V0.5Z",
    fill: "#78909C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.375H9.5V3.125H14V2.375Z",
    fill: "#78909C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 9.5H20.375V14H21.125V9.5Z",
    fill: "#5C6BC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.375H18.5V12.125H23V11.375Z",
    fill: "#5C6BC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.5H2.375V14H3.125V9.5Z",
    fill: "#78909C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.375H0.5V12.125H5V11.375Z",
    fill: "#78909C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 18.5H11.375V23H12.125V18.5Z",
    fill: "#5C6BC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.375H9.5V21.125H14V20.375Z",
    fill: "#5C6BC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H7.5V12.5H16V11Z",
    fill: "#E8762D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5H11V16H12.5V7.5Z",
    fill: "#E8762D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3H5.5V10H6.5V3Z",
    fill: "#FFA000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6H2.5V7H9.5V6Z",
    fill: "#FFA000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H17V10H18V3Z",
    fill: "#607D8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H14V7H21V6Z",
    fill: "#607D8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5H5.5V20.5H6.5V13.5Z",
    fill: "#C62828"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5H2.5V17.5H9.5V16.5Z",
    fill: "#C62828"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5H17V20.5H18V13.5Z",
    fill: "#0D47A1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5H14V17.5H21V16.5Z",
    fill: "#0D47A1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableau);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tableau.b7ab8cf9382a5048705c760e13d8e035.svg";